/**
 * Shared weight progress calculation utility.
 * Single source of truth for weight calculations across the entire app.
 *
 * Start weight: Always uses client.starting_weight (the joining/registration weight).
 * Current weight: Latest progress entry weight, or backend-computed, or starting_weight.
 * Change: currentWeight - startWeight
 *
 * This ensures all views (Dashboard, ClientDetail, ProgressCard) show progress
 * from the client's joining date to the latest update.
 */
export function calculateWeightProgress(client, progressEntries = []) {
  // Start weight is ALWAYS the client's starting weight (joining weight)
  const startWeight = client?.starting_weight || 0;

  // Sort progress by date ascending (oldest first)
  const sorted = [...progressEntries].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  let currentWeight;

  if (sorted.length > 0) {
    // Best source: latest progress entry
    currentWeight = sorted[sorted.length - 1].weight;
  } else if (client?.latest_progress_weight != null) {
    // Backend-computed from progress entries (used by Dashboard which doesn't load entries)
    currentWeight = client.latest_progress_weight;
  } else {
    // No progress yet — current = starting
    currentWeight = client?.current_weight || startWeight;
  }

  const change = parseFloat((currentWeight - startWeight).toFixed(1));

  return { startWeight, currentWeight, change };
}
